import React from 'react'
import { observer } from 'mobx-react-lite'

import { WbProductsTable } from './WbProductsTable'
import { OzonProductsTable } from './OzonProductsTable'
import { YandexMarketProductsTable } from './YandexMarketProductsTable'

import { useStore } from '../hooks/storeHook'
import { useStoreAccountOptional } from '../hooks/routeHooks'

import { wbProductColumns } from '../types/wbColumns'
import { ozonProductColumns } from '../types/ozonColumns'
import { createYmProductColumns } from '../types/yandexMarketColumns'

import { UnprocessedValueError } from '../common/tsUtils'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export const StoreProductsTable =
  observer(
    () => {
      const {productStore} = useStore()

      const account = useStoreAccountOptional()

      if (!account) {
        console.error(`Bad account in StoreProductsTable at ${window.location.href}`)
        return null
      }

      const {integrationType} = account

      switch (integrationType) {
        case undefined:
          return null

        case IntegrationType.Ozon:
          return <OzonProductsTable
            products={productStore.createOzonProductsTable(account.id)}
            columns={ozonProductColumns}
            accountId={account.id}
            accountName={account.name}
          />

        case IntegrationType.Wildberries:
          return <WbProductsTable
            products={productStore.createWbProductsTable(account.id)}
            columns={wbProductColumns}
            accountId={account.id}
            accountName={account.name}
          />

        case IntegrationType.YandexMarket:
          return <YandexMarketProductsTable
            products={productStore.createYandexMarketProductsTable(account.id)}
            columns={createYmProductColumns(account)}
            accountId={account.id}
            accountName={account.name}
          />

        default:
          throw new UnprocessedValueError('StoreIntegrationType', integrationType)
      }
    })